$(document).ready(function () {
  function initSlickOnMobile() {
    if ($(window).width() <= 768) {
      // Initialize .blog_mob_slider if not already initialized
      if (!$('.blog_mob_slider').hasClass('slick-initialized')) {
        $('.blog_mob_slider').slick({
          dots: true,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1
        });
      }
    } else {
      // Destroy slick if screen is larger than 768px
      if ($('.blog_mob_slider').hasClass('slick-initialized')) {
        $('.blog_mob_slider').slick('unslick');
      }
    }
  }

  // Initialize on page load
  initSlickOnMobile();

  // Re-initialize on window resize
  $(window).resize(function () {
    initSlickOnMobile();
  });
});


function directCheckout(id,event){
              event.preventDefault();
                let formData = {
                               id: id,
                               quantity: 1,
                  };
                $.ajax({
                   url: '/cart/add',
                   type: 'POST',
                   data: formData,
                  success: function(response){
                        window.location.href = '/checkout';
                  }
                });
           }


    
           
$('.hom-ban-slide').slick({
slidesToScroll: 1,
arrows: false,
infinite: true,
autoplay: true,
autoplaySpeed: 4000,
dots: false  
});


// $('.hom-ban-slide').slick({
//   dots: false,
//   arrows:false,
//   fade: true,
//   cssEase: 'linear',
//   autoplay: false,
//   autoplaySpeed: 2000,
//   infinite: true,
//   speed: 300,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 3,
//         infinite: true,
//         dots: false
//       }
//     },
//     {
//       breakpoint: 989,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 749,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//     // You can unslick at a given breakpoint now by adding:
//     // settings: "unslick"
//     // instead of a settings object
//   ]
// });